export default [
  {
    headerName: 'Patient ID',
    field: 'patientNumber',
    cellClass: 'no-border',
    filter: 'agTextColumnFilter',
  },
  {
    headerName: 'Last Name',
    field: 'lastName',
    cellClass: 'no-border',
    filter: 'agTextColumnFilter',
  },
  {
    headerName: 'First Name',
    field: 'firstName',
    cellClass: 'no-border',
    filter: 'agTextColumnFilter',
  },
  {
    headerName: 'DOB',
    field: 'formattedDOB',
    cellClass: 'no-border',
    filter: 'agDateColumnFilter',
  },
  {
    headerName: 'Payer Type',
    field: 'payerType',
    cellClass: 'no-border',
  },
  {
    headerName: 'LOC',
    field: 'loc',
    cellClass: 'no-border',
  },
  {
    headerName: 'Site',
    field: 'siteName',
    cellClass: 'no-border',
  },
];
